<template>
	<div>
		<div v-if="!localUserLoanPayment">
			اطلاعات کامل نمی باشد
		</div>
		<div style="direction: rtl;border:1px solid #000;padding:5px;font-size: 13px;" v-else>
			<div style="font-size: 16px;text-align: center;padding: 5px 0;"> {{ businessTitle }}</div>
			<div style="display: flex;justify-content: space-between;">
				<div style="">پرونده: {{ member.userCode }}</div>
				<div style="border:1px solid #000; display: flex;padding: 5px;align-items: center;font-size: 12px;">
					<span>نحوه پرداخت:</span>
					<span style="padding: 0 10px 0 5px;">به حساب</span>
					<span style="width: 20px;height: 20px;border: 1px solid #000;display: inline-block;-webkit-print-color-adjust: exact; print-color-adjust: exact;" :style="{ backgroundColor: localUserLoanPayment.paymentMethod === 2 ? '#000' : 'transparent' }"></span>
					<span style="padding: 0 10px 0 5px;">درگاه</span>
					<span style="width: 20px;height: 20px;border: 1px solid #000;display: inline-block;-webkit-print-color-adjust: exact; print-color-adjust: exact;" :style="{ backgroundColor: localUserLoanPayment.paymentMethod === 4 ? '#000' : 'transparent' }"></span>
					<span style="padding: 0 10px 0 5px;">چک</span>
					<span style="width: 20px;height: 20px;border: 1px solid #000;display: inline-block;-webkit-print-color-adjust: exact; print-color-adjust: exact;" :style="{ backgroundColor: 'transparent' }"></span>
					<span style="padding: 0 10px 0 5px;">نقدی</span>
					<span style="width: 20px;height: 20px;border: 1px solid #000;display: inline-block;-webkit-print-color-adjust: exact; print-color-adjust: exact;" :style="{ backgroundColor: localUserLoanPayment.paymentMethod === 1 ? '#000' : 'transparent' }"></span>
					<span style="padding: 0 10px 0 5px;">کارتخوان</span>
					<span style="width: 20px;height: 20px;border: 1px solid #000;display: inline-block;-webkit-print-color-adjust: exact; print-color-adjust: exact;" :style="{ backgroundColor: localUserLoanPayment.paymentMethod === 5 ? '#000' : 'transparent' }"></span>
				</div>
			</div>
			<div style="text-align: center;margin-bottom: 10px;position: relative;padding-top: 10px;">
				پرداخت اقساط
				<div style="position: absolute;left: 20px;top:10px;">
					مورخ: <span style="padding: 2px;border-bottom: 1px dotted #000;">{{ new Date().toLocaleDateString('fa-IR').toString().toPersianDigits() }}</span>
				</div>
			</div>
			<div style="line-height: 2.4;">
				پروژه <span style="padding: 2px;border-bottom: 1px dotted #000;min-width: 150px;display: inline-block;text-align: center;height: 22px;">{{ localUserLoanPayment.userLoanModel.loanModel.title }}</span>
				شماره قرارداد <span style="padding: 2px;border-bottom: 1px dotted #000;min-width: 75px;display: inline-block;text-align: center;height: 22px;">{{ localUserLoanPayment.userLoanModel.secondaryCode }}</span>
				وام شماره <span style="padding: 2px;border-bottom: 1px dotted #000;min-width: 50px;display: inline-block;text-align: center;height: 22px;">{{ localUserLoanPayment.userLoanModel.code.toString().toPersianDigits() }}</span>
				قسط شماره <span style="padding: 2px;border-bottom: 1px dotted #000;min-width: 50px;display: inline-block;text-align: center;height: 22px;">{{ localUserLoanPayment.installmentNumber.toString().toPersianDigits() }}</span>
				<br />
				آقای/خانم <span style="padding: 2px;border-bottom: 1px dotted #000;min-width: 150px;display: inline-block;text-align: center;height: 22px;">{{ member ? member.fullName : '' }}</span>
				کد ملی <span style="padding: 2px;border-bottom: 1px dotted #000;min-width: 75px;display: inline-block;text-align: center;height: 22px;">{{ member ? member.nationalCode : '' }}</span>
				مبلغ <span style="padding: 2px;border-bottom: 1px dotted #000;min-width: 75px;display: inline-block;text-align: center;height: 22px;">{{ amounts }}</span>
				را در تاریخ <span style="padding: 2px;border-bottom: 1px dotted #000;min-width: 100px;display: inline-block;text-align: center;height: 22px;">{{ dates }}</span>
				طی رسید پرداختی با شماره مرجع تراکنش <span style="padding: 2px;border-bottom: 1px dotted #000;min-width: 100px;display: inline-block;text-align: center;height: 22px;">{{ transactionCode }}</span>
				با {{ localUserLoanPayment.delayDay < 0 ? 'زودکرد' : 'تاخیر' }} <span style="padding: 2px;border-bottom: 1px dotted #000;min-width: 50px;display: inline-block;text-align: center;height: 22px;">&lrm;{{ Math.abs(localUserLoanPayment.delayDay).toString().toPersianDigits() }}</span>
					روزه پرداخت {{ localUserLoanPayment.delayDay >= 0 ? '، که از این مبلغ' : 'و' }} مبلغ
					<span style="padding: 2px;border-bottom: 1px dotted #000;min-width: 75px;display: inline-block;text-align: center;height: 22px;">{{ localUserLoanPayment.delayPrice.toString().toPriceFormat().toPersianDigits() }}</span>
					به عنوان {{ localUserLoanPayment.delayDay < 0 ? 'زودکرد' : 'جریمه' }} {{ localUserLoanPayment.delayDay < 0 ? 'کسر' : 'واریز' }} گردیده است. <span v-if="localUserLoanPayment.discount">همچنین مبلغ <span style="padding: 2px;border-bottom: 1px dotted #000;min-width: 75px;display: inline-block;text-align: center;height: 22px;">{{ localUserLoanPayment.discount.toString().toPriceFormat().toPersianDigits() }}</span> به عنوان تخفیف شامل شده است.</span>
			</div>

			<div style="text-align: right;margin-bottom: 20px;position: relative;padding-top: 20px;font-size: 12px;">
				{{ descriptions }}
			</div>

			<div style="text-align: center;margin-bottom: 5px;position: relative;padding-top: 20px;">
				تایید حسابداری
			</div>

			<div>
				پرداخت طی حواله <span style="padding: 2px;border-bottom: 1px dotted #000;min-width: 150px;display: inline-block;text-align: center;height: 22px;"></span>
				سند <span style="padding: 2px;border-bottom: 1px dotted #000;min-width: 100px;display: inline-block;text-align: center;height: 22px;"></span>
				مورخ <span style="padding: 2px;border-bottom: 1px dotted #000;min-width: 100px;display: inline-block;text-align: center;height: 22px;"></span>
				در حساب شرکت واریز و ثبت گردیده و مورد تایید می‌باشد.
			</div>

			<div style="text-align: center;margin-bottom: 20px;position: relative;padding-top: 25px;">
				مالی
			</div>

		</div>
	</div>
</template>

<script>
import { get } from 'vuex-pathify'
import api from '@/util/app-api'
import toast from '@/util/toast'
import { sumBy, cloneDeep } from 'lodash'

export default {
	name: 'ArvandUserLoanPaymentPrintHtml',
	components: {
	},
	props: {
		userLoanPayment: {
			type: Object,
		},
		member: {
			type: Object,
		},
		area: {
			type: String,
			default: 'admin'
		}
	},
	data: () => ({
		html: '',
		localUserLoanPayment: null,
	}),
	mounted() {
		this.fillHtml()
	},
	computed: {
		...get('siteConfig', [
			'fullTitle', 'baseUrl'
		]),
		...get('appSettings', [
			'settings'
		]),
		...get('auth', [
			'getCurrentUser',
		]),
		businessTitle() {
			return this.area === 'agent' ? this.getCurrentUser?.userData?.businessName : this.settings?.businessTitle || this.fullTitle || ''
		},
		currentUser() {
			var user = this.getCurrentUser
			if (user && user.userData) { return `${user.userData.fullName}` }
			return ''
		},
		customerCode() {
			var user = this.getCurrentUser
			return user?.userData?.customer?.code || ''
		},
		transactionCode() {
			return (this.localUserLoanPayment.memberPurchases || []).filter(x => x.isPaymentSuccess).map(x => x.transactionCode).join(' و ')
		},
		dates() {
			let date = this.localUserLoanPayment.saveDate_Persian.date.toString().toPersianDigits()
			date += this.localUserLoanPayment.loanPaymentOthers ? ' و ' + this.localUserLoanPayment.loanPaymentOthers.map(x => x.saveDate_Persian.date.toString().toPersianDigits()).join(' و ') : ''
			return date
		},
		descriptions() {
			let descriptions = this.localUserLoanPayment.description || ''
			descriptions += this.localUserLoanPayment.loanPaymentOthers ? '. ' + this.localUserLoanPayment.loanPaymentOthers.map(x => x.description).join('. ') : ''
			return descriptions
		},
		amounts() {
			let amounts = this.localUserLoanPayment.amount.toString().toPriceFormat().toPersianDigits()
			amounts += this.localUserLoanPayment.loanPaymentOthers ? ' و ' + this.localUserLoanPayment.loanPaymentOthers.map(x => x.amount.toString().toPriceFormat().toPersianDigits()).join(' و ') : ''
			return amounts
		},

	},
	methods: {
		fillHtml() {
			this.localUserLoanPayment = cloneDeep(this.userLoanPayment)
			this.$nextTick(() => {
				this.$emit('ready')
			})
		},
		getUserLoan() {
			return api.get(`${this.area}/userLoan/get/` + this.userLoanId)
				.catch(err => {
					toast.error(err.message)
				})
		},
	}
}
</script>
<style scoped></style>